import { createContext, useContext } from "react";
import type { Client } from "../types/client.types";

interface ClientOverviewContextType {
  client: Client | null;
}

const ClientOverviewContext = createContext<ClientOverviewContextType | null>(
  null,
);

export const useClientOverview = () => {
  const context = useContext(ClientOverviewContext);
  if (!context) {
    throw new Error("useClientOverview must be used within provider");
  }
  return context;
};

export default ClientOverviewContext;
